export const getCookie = (name: string) => {
  const cookies = document.cookie.split('; ');
  for (const c of cookies) {
    const [key, val] = c.split('=');
    if (key === name) return decodeURIComponent(val);
  }
  return '';
};

export const getPixelCookies = () => {
  const fbc = getCookie('_fbc');
  const fbp = getCookie('_fbp');
  return { fbc, fbp };
};
